import { dollarFormat } from 'helpers/paymentHelpers';
import {
	isEmpty,values
} from 'lodash';
import React from 'react';

const Disclaimer = ({
	cart, medCheckout,
}) => {
	const {
		cartTotalCents, products,
	} = cart;
	let autoRefillMeds = 0;
	let shortnames = [];
	// console.log(cart);
	let autoRefillPrice = values(products).reduce((prev, { autorefill }) => {
		if (autorefill && !isEmpty(autorefill) && autorefill.selected) {
			if (autorefill.shortname) {
				shortnames.push(autorefill.shortname);
			}
			autoRefillMeds++;
			return prev + autorefill.price_cents;
		}
		return prev;
	},
	0);
	let autoRefillName = 'Auto Refill'; // default (fallback) name
	if (shortnames.length) {
		autoRefillName = shortnames.join(' / ') + ' Auto Refill';
	}

	if (!cartTotalCents) {
		return null;
	}

	if (medCheckout) {
		return (
			<p className="fine-print" style={{
				marginTop: 0,
				marginBottom: '5px',
				color: '#000000',
				fontSize: '12px',
			}}><strong style={{ fontSize: '14px !important' }}>Total {dollarFormat(cartTotalCents)}</strong> including free shipping</p>
		);
	}

	return (
		<>
			<p className="fine-print">
				{autoRefillPrice ? (
					`You will be charged ${dollarFormat(cartTotalCents)} today, and ${dollarFormat(autoRefillPrice)} every three months for your ${autoRefillName} medication${autoRefillMeds > 1 ? 's' : ''}.`
				) : (
					`You will be charged ${dollarFormat(cartTotalCents)} for this one time purchase.`
				)}
			</p>
		</>
	)
};

export default Disclaimer;
